export default __webpack_public_path__ + "static/media/pin-pickup.594f0a72.png";